import React from 'react'
import { Icon, Text } from 'components'
import styles from './Financing.module.scss'

const Financing = () => (
  <span className={styles.financing}>
    <span className={styles.indicator}>
      <Icon type="hand" size={26} color="darkColor" />{' '}
      <Text>Quer financiar o imóvel?</Text>
    </span>
    <button type="button" className={styles.button} onClick={null}>
      <a
        href="https://simulador.credihome.com.br/resale"
        target="_blank"
        rel="noreferrer"
      >
        Aprove aqui seu crédito
      </a>
    </button>
  </span>
)

Financing.propTypes = {}

Financing.defaultProps = {}

export default React.memo(Financing)
